'use client';

import { usePathname } from '@/i18n/routing';
import { Sidebar } from '@/components/admin/Sidebar';
import { type Session } from '@/lib/auth-client';

export function AdminLayoutClient({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  const pathname = usePathname();
  const isLoginPage = pathname === '/admin/login';

  return (
    <div className="flex min-h-screen bg-gray-100">
      {!isLoginPage ? (
        <>
          <Sidebar />
          <main className="flex-1 p-8 overflow-y-auto">
            {children}
          </main>
        </>
      ) : (
        <main className="flex-1">
          {children}
        </main>
      )}
    </div>
  );
}
